import { render } from "./fullPage.vue?vue&type=template&id=14256de4&scoped=true&lang=pug"
import script from "./fullPage.vue?vue&type=script&setup=true&lang=js"
export * from "./fullPage.vue?vue&type=script&setup=true&lang=js"

import "./fullPage.vue?vue&type=style&index=0&id=14256de4&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14256de4"]])

export default __exports__